(function(){
  'use strict';

  document.addEventListener('DOMContentLoaded', function(){

    // ===== FILTER MODAL FUNCTIONALITY =====
    var filterOverlay = document.querySelector('.gtu-gallery-video-filter-container-desktop');
    var filterButtons = document.querySelectorAll('button[data-filter-button-desktop]');
    var filterCloseBtn = document.querySelector('.gtu-gallery-video-filter-container-desktop .gtu-gallery-video-filter-close');
    var mobileFilterOverlay = document.querySelector('.gtu-gallery-video-filter-container-mobile');
    var mobileFilterBtn = document.querySelector('button[data-filter-button-mobile]');
    var mobileFilterCloseBtn = document.querySelector('.gtu-gallery-video-filter-close-mobile');

    function openFilterModal() { if(filterOverlay) filterOverlay.style.display = 'block'; }
    function closeFilterModal() { if(filterOverlay) filterOverlay.style.display = 'none'; }

    filterButtons.forEach(function(btn) { btn.addEventListener('click', openFilterModal); });
    if(filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilterModal);
    if(filterOverlay) filterOverlay.addEventListener('click', function(e) { if(e.target === filterOverlay) closeFilterModal(); });

    if(mobileFilterBtn && mobileFilterOverlay) {
      mobileFilterBtn.addEventListener('click', function(e) {
        if(window.innerWidth < 1024) { e.stopPropagation(); mobileFilterOverlay.style.display = 'block'; }
      });
    }
    if(mobileFilterCloseBtn) mobileFilterCloseBtn.addEventListener('click', function() { mobileFilterOverlay.style.display = 'none'; });
    if(mobileFilterOverlay) mobileFilterOverlay.addEventListener('click', function(e) { if(e.target === mobileFilterOverlay) mobileFilterOverlay.style.display = 'none'; });

    document.addEventListener('keydown', function(e) {
      if(e.key === 'Escape') {
        if(filterOverlay && filterOverlay.style.display === 'block') closeFilterModal();
        if(mobileFilterOverlay && mobileFilterOverlay.style.display === 'block') mobileFilterOverlay.style.display = 'none';
      }
    });

    // ===== FILTER SETUP =====
    function setupFilter(config) {
      var wheelSel = config.wheel;
      var makeSel = config.make;
      var modelSel = config.model;
      var yearSel = config.year;
      var applyBtn = config.apply;
      var clearBtn = config.clear;
      var keywordInput = config.keyword;
      var searchBtn = config.search;
      var container = config.container;
      var countEl = config.countEl;
      var closeFn = config.closeFn;

      if (!container) return;

      var items = container.querySelectorAll('a[data-title]');
      var totalCount = items.length;

      // Build video data array
      var videos = [];
      items.forEach(function(item) {
        videos.push({
          el: item,
          matched: true,
          title: (item.getAttribute('data-title') || '').toLowerCase(),
          product: (item.getAttribute('data-featured-product') || '').toLowerCase()
        });
      });

      // ===== PAGINATION (client-side, 8 per page, over the filter-matched set) =====
      // Mirrors the vehicle gallery: a card is shown only if it matches the active
      // filter AND falls in the current page slice. Controls re-render on filter change.
      var pager = config.pager;
      var pagerSide = config.pagerSide || 'mobile';
      var PAGE_SIZE = 8;
      var currentPage = 1;
      var PREV_SVG = '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.796875 8.80259L0 8.00235L0.796875 7.20212L7.17188 0.800235L7.96875 0L9.55781 1.60047L8.76094 2.40071L4.30781 6.87261H22.875H24V9.1321H22.875H4.30781L8.76094 13.604L9.55781 14.4042L7.96875 16L7.17188 15.1998L0.796875 8.80259Z" fill="white"/></svg>';
      var NEXT_SVG = '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.2031 8.80259L24 8.00235L23.2031 7.20212L16.8281 0.800235L16.0312 0L14.4422 1.60047L15.2391 2.40071L19.6922 6.87261H1.125H0V9.1321H1.125H19.6922L15.2391 13.604L14.4422 14.4042L16.0312 16L16.8281 15.1998L23.2031 8.80259Z" fill="white"/></svg>';

      function matchedVideos() {
        return videos.filter(function(v) { return v.matched !== false; });
      }

      function renderPager(totalPages) {
        if (!pager) return;
        if (totalPages <= 1) { pager.innerHTML = ''; pager.hidden = true; return; }
        pager.hidden = false;
        var prevCls = 'gtu-pagination-prev-' + pagerSide;
        var nextCls = 'gtu-pagination-next-' + pagerSide;
        var nums = [], i, last = 0, html = '';
        for (i = 1; i <= totalPages; i++) {
          if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) nums.push(i);
        }
        html += '<div class="' + prevCls + '" aria-label="Previous page">' +
          (currentPage > 1 ? '<a href="#" data-page="' + (currentPage - 1) + '">' + PREV_SVG + '</a>'
                           : '<span class="is-disabled">' + PREV_SVG + '</span>') + '</div>';
        html += '<div class="gtu-page-gallary-pagination"><nav class="gtu-page-gallary-pagination-nav" role="navigation" aria-label="Video gallery pagination"><ul class="gtu-page-gallary-pagination-list">';
        nums.forEach(function(n) {
          if (n - last > 1) html += '<li class="gtu-page-gallary-pagination-item is-gap">&hellip;</li>';
          if (n === currentPage) html += '<li class="gtu-page-gallary-pagination-item is-active">' + n + '</li>';
          else html += '<li class="gtu-page-gallary-pagination-item"><a href="#" data-page="' + n + '">' + n + '</a></li>';
          last = n;
        });
        html += '</ul></nav></div>';
        html += '<div class="' + nextCls + '" aria-label="Next page">' +
          (currentPage < totalPages ? '<a href="#" data-page="' + (currentPage + 1) + '">' + NEXT_SVG + '</a>'
                                    : '<span class="is-disabled">' + NEXT_SVG + '</span>') + '</div>';
        pager.innerHTML = html;
        pager.querySelectorAll('a[data-page]').forEach(function(a) {
          a.addEventListener('click', function(e) {
            e.preventDefault();
            currentPage = parseInt(a.getAttribute('data-page'), 10) || 1;
            renderPage();
            if (container && container.scrollIntoView) container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      }

      function renderPage() {
        var matched = matchedVideos();
        var totalPages = Math.max(1, Math.ceil(matched.length / PAGE_SIZE));
        if (currentPage > totalPages) currentPage = totalPages;
        if (currentPage < 1) currentPage = 1;
        var start = (currentPage - 1) * PAGE_SIZE;
        videos.forEach(function(v) { v.el.style.display = 'none'; });
        matched.slice(start, start + PAGE_SIZE).forEach(function(v) { v.el.style.display = ''; });
        renderPager(totalPages);
      }

      // Helper: check if video matches filters (excluding one field)
      function matchesFilters(v, excludeField) {
        var wVal = (excludeField === 'wheel') ? '' : (wheelSel ? wheelSel.value.toLowerCase() : '');
        var mVal = (excludeField === 'make') ? '' : (makeSel ? makeSel.value.toLowerCase() : '');
        var mdVal = (excludeField === 'model') ? '' : (modelSel ? modelSel.value.toLowerCase() : '');
        var yVal = (excludeField === 'year') ? '' : (yearSel ? yearSel.value : '');

        if (wVal && v.product.indexOf(wVal) === -1) return false;
        if (mVal && v.title.indexOf(mVal) === -1) return false;
        if (mdVal && v.title.indexOf(mdVal) === -1) return false;
        if (yVal && yVal !== 'pre-2017') {
          if (v.title.indexOf(yVal) === -1) return false;
        } else if (yVal === 'pre-2017') {
          var hasRecent = false;
          for (var y = 2017; y <= 2030; y++) { if (v.title.indexOf(String(y)) !== -1) { hasRecent = true; break; } }
          var hasOld = false;
          for (var oy = 1900; oy < 2017; oy++) { if (v.title.indexOf(String(oy)) !== -1) { hasOld = true; break; } }
          if (!hasOld && hasRecent) return false;
        }
        return true;
      }

      // Cascading: update dropdown options based on other selections
      function updateDropdown(selectEl, field) {
        if (!selectEl) return;
        var currentVal = selectEl.value;
        var matched = videos.filter(function(v) { return matchesFilters(v, field); });

        var uniqueVals = {};
        matched.forEach(function(v) {
          if (field === 'wheel') {
            if (v.product) uniqueVals[v.product] = true;
          } else if (field === 'year') {
            // Extract 4-digit years from title
            var yearMatch = v.title.match(/\b(19\d{2}|20\d{2})\b/g);
            if (yearMatch) yearMatch.forEach(function(yr) { uniqueVals[yr] = true; });
          } else {
            // For make/model, get values from the option list that match titles
            var opts = selectEl.querySelectorAll('option');
            opts.forEach(function(opt) {
              if (opt.value && v.title.indexOf(opt.value.toLowerCase()) !== -1) {
                uniqueVals[opt.value] = opt.textContent;
              }
            });
          }
        });

        // For wheel and make/model, rebuild from original options that have matches
        var placeholder = selectEl.options[0] ? selectEl.options[0].textContent : 'Select';
        var originalOptions = selectEl.getAttribute('data-original-options');
        if (!originalOptions) {
          // Save original options on first run
          var opts = [];
          for (var i = 1; i < selectEl.options.length; i++) {
            opts.push({ value: selectEl.options[i].value, text: selectEl.options[i].textContent });
          }
          selectEl.setAttribute('data-original-options', JSON.stringify(opts));
          originalOptions = selectEl.getAttribute('data-original-options');
        }

        var origOpts = JSON.parse(originalOptions);
        selectEl.innerHTML = '<option value="">' + placeholder + '</option>';

        origOpts.forEach(function(opt) {
          // Check if this option value would produce results
          var wouldMatch = matched.some(function(v) {
            if (field === 'wheel') return v.product.indexOf(opt.value.toLowerCase()) !== -1;
            if (field === 'year') {
              if (opt.value === 'pre-2017') {
                var hasOld = false;
                for (var oy = 1900; oy < 2017; oy++) { if (v.title.indexOf(String(oy)) !== -1) { hasOld = true; break; } }
                return hasOld;
              }
              return v.title.indexOf(opt.value) !== -1;
            }
            return v.title.indexOf(opt.value.toLowerCase()) !== -1;
          });
          if (wouldMatch) {
            var o = document.createElement('option');
            o.value = opt.value;
            o.textContent = opt.text;
            selectEl.appendChild(o);
          }
        });

        // Restore selection if still valid
        if (currentVal) {
          var found = false;
          for (var j = 0; j < selectEl.options.length; j++) {
            if (selectEl.options[j].value === currentVal) { found = true; break; }
          }
          selectEl.value = found ? currentVal : '';
        }
      }

      function updateAllDropdowns(changedField) {
        if (changedField !== 'wheel') updateDropdown(wheelSel, 'wheel');
        if (changedField !== 'make') updateDropdown(makeSel, 'make');
        if (changedField !== 'model') updateDropdown(modelSel, 'model');
        if (changedField !== 'year') updateDropdown(yearSel, 'year');
      }

      // Button active state
      function updateButtonState() {
        if (!applyBtn) return;
        var any = (wheelSel && wheelSel.value) || (makeSel && makeSel.value) ||
                  (modelSel && modelSel.value) || (yearSel && yearSel.value) ||
                  (keywordInput && keywordInput.value.trim());
        if (any) { applyBtn.classList.add('gtu-filter-button-active'); }
        else { applyBtn.classList.remove('gtu-filter-button-active'); }
      }

      // Cascading change listeners
      if (wheelSel) wheelSel.addEventListener('change', function() { updateAllDropdowns('wheel'); updateButtonState(); });
      if (makeSel) makeSel.addEventListener('change', function() { updateAllDropdowns('make'); updateButtonState(); });
      if (modelSel) modelSel.addEventListener('change', function() { updateAllDropdowns('model'); updateButtonState(); });
      if (yearSel) yearSel.addEventListener('change', function() { updateAllDropdowns('year'); updateButtonState(); });
      if (keywordInput) keywordInput.addEventListener('input', updateButtonState);

      // Apply filter
      function applyFilter() {
        var wVal = wheelSel ? wheelSel.value.toLowerCase() : '';
        var mVal = makeSel ? makeSel.value.toLowerCase() : '';
        var mdVal = modelSel ? modelSel.value.toLowerCase() : '';
        var yVal = yearSel ? yearSel.value : '';
        var kw = keywordInput ? keywordInput.value.trim().toLowerCase() : '';
        var count = 0;

        videos.forEach(function(v) {
          var show = true;
          if (wVal && v.product.indexOf(wVal) === -1) show = false;
          if (mVal && v.title.indexOf(mVal) === -1) show = false;
          if (mdVal && v.title.indexOf(mdVal) === -1) show = false;
          if (yVal && yVal !== 'pre-2017') {
            if (v.title.indexOf(yVal) === -1) show = false;
          } else if (yVal === 'pre-2017') {
            var hasRecent = false;
            for (var y = 2017; y <= 2030; y++) { if (v.title.indexOf(String(y)) !== -1) { hasRecent = true; break; } }
            var hasOld = false;
            for (var oy = 1900; oy < 2017; oy++) { if (v.title.indexOf(String(oy)) !== -1) { hasOld = true; break; } }
            if (!hasOld && hasRecent) show = false;
          }
          if (kw && v.title.indexOf(kw) === -1) show = false;
          v.matched = show;
          if (show) count++;
        });

        if (countEl) countEl.textContent = count;
        currentPage = 1;
        renderPage();
      }

      // Clear filters
      function clearFilters() {
        if (wheelSel) wheelSel.value = '';
        if (makeSel) makeSel.value = '';
        if (modelSel) modelSel.value = '';
        if (yearSel) yearSel.value = '';
        if (keywordInput) keywordInput.value = '';
        videos.forEach(function(v) { v.matched = true; });
        if (countEl) countEl.textContent = totalCount;
        if (applyBtn) applyBtn.classList.remove('gtu-filter-button-active');
        // Reset dropdowns to show all options
        updateAllDropdowns('');
        currentPage = 1;
        renderPage();
      }

      // Initial paginated render (page 1 of all videos)
      renderPage();

      // Bind buttons
      if (applyBtn) applyBtn.addEventListener('click', function() { applyFilter(); closeFn(); });
      if (clearBtn) clearBtn.addEventListener('click', function() { clearFilters(); closeFn(); });
      if (searchBtn) searchBtn.addEventListener('click', function() { applyFilter(); closeFn(); });
      if (keywordInput) keywordInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); applyFilter(); closeFn(); }
      });
    }

    // ===== INIT DESKTOP FILTER =====
    setupFilter({
      wheel: document.querySelector('[data-filter-wheel-desktop]'),
      make: document.querySelector('[data-filter-make-desktop]'),
      model: document.querySelector('[data-filter-model-desktop]'),
      year: document.querySelector('[data-filter-year-desktop]'),
      apply: document.querySelector('[data-apply-filter-desktop]'),
      clear: document.querySelector('[data-clear-filter-desktop]'),
      keyword: document.querySelector('[data-keyword-desktop]'),
      search: document.querySelector('[data-search-desktop]'),
      container: document.querySelector('.gtu-page-gallary-video-item-metaobject-container-desktop'),
      countEl: document.querySelector('.gtu-page-gallary-title-container-digit-desktop'),
      pager: document.querySelector('[data-video-pager="desktop"]'),
      pagerSide: 'desktop',
      closeFn: closeFilterModal
    });

    // ===== INIT MOBILE FILTER =====
    setupFilter({
      wheel: document.querySelector('[data-filter-wheel-mobile]'),
      make: document.querySelector('[data-filter-make-mobile]'),
      model: document.querySelector('[data-filter-model-mobile]'),
      year: document.querySelector('[data-filter-year-mobile]'),
      apply: document.querySelector('[data-apply-filter-mobile]'),
      clear: document.querySelector('[data-clear-filter-mobile]'),
      keyword: document.querySelector('[data-keyword-mobile]'),
      search: document.querySelector('[data-search-mobile]'),
      container: document.querySelector('.gtu-page-gallary-video-item-metaobjec-container'),
      countEl: document.querySelector('.gtu-page-gallary-title-container-digit'),
      pager: document.querySelector('[data-video-pager="mobile"]'),
      pagerSide: 'mobile',
      closeFn: function() { if(mobileFilterOverlay) mobileFilterOverlay.style.display = 'none'; }
    });

  });

})();
